(() => {
  const body = document.body;
  if (!body) return;

  const anyVisible = (selectors) => {
    try {
      return Array.from(document.querySelectorAll(selectors)).some((el) => {
        if (el.hidden) return false;
        const style = window.getComputedStyle(el);
        const rect = el.getBoundingClientRect();
        return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
      });
    } catch (e) {
      return false;
    }
  };

  const releaseStaleScrollLocks = () => {
    const cartOpen = anyVisible('cart-drawer[open] .wt-cart__drawer, .wt-cart__drawer.wt-cart__drawer--open');
    if (!cartOpen) body.classList.remove('page-overlay-cart-on');

    const themeModalOpen = anyVisible('dialog[open], modal-dialog[open], .wt__quick-buy__container--open, .wt-drawer--nav[open], .wt-select__drawer[open]');
    if (!themeModalOpen) {
      body.classList.remove('overflow-hidden', 'quick-buy-page-overlay', 'menu-drawer-overlay-on');
    }

    // Only clear inline locks when there is no visible modal/dialog. This catches stale locks
    // left behind after resize/orientation/app initialization without fighting an active popup.
    const modalOpen = anyVisible('dialog[open], [role="dialog"][aria-modal="true"], [aria-modal="true"]');
    if (!modalOpen) {
      if (body.style.overflow === 'hidden') body.style.removeProperty('overflow');
      if (document.documentElement.style.overflow === 'hidden') document.documentElement.style.removeProperty('overflow');
      if (body.style.position === 'fixed' && !body.dataset.vpodKeepFixed) body.style.removeProperty('position');
    }
  };

  window.addEventListener('pageshow', releaseStaleScrollLocks, { passive: true });
  window.addEventListener('orientationchange', () => window.setTimeout(releaseStaleScrollLocks, 120), { passive: true });
  window.addEventListener('resize', () => window.setTimeout(releaseStaleScrollLocks, 120), { passive: true });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) window.setTimeout(releaseStaleScrollLocks, 50);
  });
  document.addEventListener('click', () => window.setTimeout(releaseStaleScrollLocks, 80), { passive: true });
  window.setTimeout(releaseStaleScrollLocks, 250);
  window.setTimeout(releaseStaleScrollLocks, 1800);
})();

/* VPod mobile promo gate: keep the Klaviyo onsite offer from interrupting the
   first part of a mobile/tablet visit. No MutationObserver is used; we react
   only to Klaviyo's own form event plus a few light startup checks. */
(() => {
  const mq = window.matchMedia('(max-width: 1024px)');
  if (!mq.matches) return;

  const hidden = new Set();
  let allowed = false;

  const isKlaviyoNode = (el) => {
    if (!(el instanceof Element)) return false;
    const signature = `${el.id || ''} ${el.className || ''}`.toLowerCase();
    return signature.includes('klaviyo') || signature.includes('kl-private-reset-css') || el.classList.contains('needsclick');
  };

  const findOverlayRoot = (el) => {
    let node = el;
    let fixed = null;
    for (let i = 0; node && node !== document.body && i < 10; i += 1, node = node.parentElement) {
      const style = window.getComputedStyle(node);
      if (style.position === 'fixed') fixed = node;
      if (node.getAttribute('role') === 'dialog' || node.getAttribute('aria-modal') === 'true') return node;
    }
    return fixed;
  };

  const suppressEarlyKlaviyo = () => {
    if (allowed || !mq.matches) return;
    const nodes = document.querySelectorAll('.needsclick, [class*="kl-private-reset-css"], [id*="klaviyo"], [id*="Klaviyo"], [class*="klaviyo"], [class*="Klaviyo"]');
    nodes.forEach((node) => {
      if (!isKlaviyoNode(node)) return;
      const root = findOverlayRoot(node);
      if (!root || root === document.body || root === document.documentElement) return;
      const rect = root.getBoundingClientRect();
      if (rect.width < 1 || rect.height < 1) return;
      if (root.dataset.vpodPromoSuppressed !== 'true') {
        root.dataset.vpodPromoDisplay = root.style.getPropertyValue('display') || '';
        root.dataset.vpodPromoDisplayPriority = root.style.getPropertyPriority('display') || '';
      }
      root.dataset.vpodPromoSuppressed = 'true';
      root.style.setProperty('display', 'none', 'important');
      hidden.add(root);
    });

    // A suppressed popup should never be allowed to leave the page locked.
    if (hidden.size) {
      document.body?.classList.remove('overflow-hidden');
      if (document.body?.style.overflow === 'hidden') document.body.style.removeProperty('overflow');
      if (document.documentElement.style.overflow === 'hidden') document.documentElement.style.removeProperty('overflow');
    }
  };

  const allowPromo = () => {
    if (allowed) return;
    allowed = true;
    hidden.forEach((node) => {
      if (!node?.isConnected || node.dataset.vpodPromoSuppressed !== 'true') return;
      const priorDisplay = node.dataset.vpodPromoDisplay || '';
      const priorPriority = node.dataset.vpodPromoDisplayPriority || '';
      if (priorDisplay) node.style.setProperty('display', priorDisplay, priorPriority);
      else node.style.removeProperty('display');
      delete node.dataset.vpodPromoSuppressed;
      delete node.dataset.vpodPromoDisplay;
      delete node.dataset.vpodPromoDisplayPriority;
    });
    hidden.clear();
    window.removeEventListener('scroll', checkProgress);
  };

  const checkProgress = () => {
    const scrollable = Math.max(1, document.documentElement.scrollHeight - window.innerHeight);
    if ((window.scrollY / scrollable) >= 0.35) allowPromo();
  };

  window.addEventListener('klaviyoForms', (event) => {
    if (event?.detail?.type === 'open' && !allowed) {
      window.setTimeout(suppressEarlyKlaviyo, 0);
      window.setTimeout(suppressEarlyKlaviyo, 120);
    }
  });
  window.addEventListener('scroll', checkProgress, { passive: true });
  window.setTimeout(suppressEarlyKlaviyo, 350);
  window.setTimeout(suppressEarlyKlaviyo, 1200);
  window.setTimeout(suppressEarlyKlaviyo, 2500);
  window.setTimeout(allowPromo, 25000);
})();
